import api from '@/services/index.js'

async function fetchAffiliate(callback) {
  await api
    .get('/user-profile-composite/v1/users/affiliate')
    .then((v) => {
      callback({ status: true, data: v.data, message: v.message })
    })
    .catch((e) => {
      callback({ status: false, data: e.message, message: v.message })
    })
    .finally(() => {})
}
async function WithdrawAffiliate(callback) {
  await api
    .get('/user-profile-composite/v1/users/affiliate/vertify')
    .then((v) => {
      if (v.success == true) {
        callback({ status: true, data: v.data, message: v.message })
      } else {
        callback({ status: false, data: v.message, message: v.message })
      }
    })
    .catch((e) => {
      callback({ status: false, data: e.message, message: e.message })
    })
    .finally(() => {})
}
export { fetchAffiliate, WithdrawAffiliate }



// WEBPACK FOOTER //
// ./src/services/modules/af.js